import { apiRequest } from './client';
import type { SiteRepository } from '../../application/ports/SiteRepository';
import type { Site } from '../../domain/Site';
import type { FieldStation } from '../../domain/FieldMap';

export class HttpSiteRepository implements SiteRepository {
  list() {
    return apiRequest<{ sites: Site[] }>('/sites');
  }

  create(input: { name: string; lat?: number | null; lng?: number | null }) {
    return apiRequest<{ site: Site }>('/sites', { method: 'POST', body: JSON.stringify(input) });
  }

  update(id: string, input: Partial<{ name: string; lat: number | null; lng: number | null }>) {
    return apiRequest<{ site: Site }>(`/sites/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
  }

  delete(id: string) {
    return apiRequest<void>(`/sites/${id}`, { method: 'DELETE' });
  }

  fetchField(id: string) {
    return apiRequest<{ stations: FieldStation[] }>(`/sites/${id}/field`);
  }
}
